import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { sanLuisConfig } from "./data";

export default function SanLuisPage() {
  return <CityPageTemplate config={sanLuisConfig} />;
}